import moment from 'moment'
import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { hideLoader, showLoader } from '../../modules/actions'
import Request from '../../request'
import { connect } from 'react-redux'
import styles from '../../containers/Desk/counselling/all/styles.less'
import { RightsWrapper } from './utils'

@Form.create()
class ListFollowUps extends React.Component {
    state = {
        visible: true,
        childrenDrawer: false,
        arr: [],
        loading: false,
        parentRatings: [],
        subRatings: [],
        followUpObject: []
    }

    loadFollowUpTypes = async () => {
        let params = {
            results: 10000,
            count: 10000
        }
        let response = await Request.getFollowUpTypes(params)
        let followUpObject = []
        _.each(response.data, (followUp) => {
            followUpObject.push({ id: followUp.name, display: followUp.name })
        })
        this.setState({ followUpObject })
    }

    getAllRatings = async () => {
        let response = await Request.getRatingsDetails({
            results: 1000,
            count: 1000
        })
        this.setState({ parentRatings: response.data })
    }
    getAllSUbRatings = async (id) => {
        let response = await Request.getSubRatingsDetails({
            results: 1000,
            count: 1000,
            parentRatingId: id
        })
        this.setState({ subRatings: response.data })
    }

    componentDidMount() {
        this.loadStudentFollowUps();
        this.getAllRatings();
        this.loadFollowUpTypes()
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }
    renderStatus = (val) => {
        if (val === 'Didn\'t Pick up Call') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Out Of town') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Not Interested') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }

        if (val === 'Busy, Call Later') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
        if (val === 'Active') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }


    loadStudentFollowUps = async () => {
        this.setState({ loading: true })
        let response = await Request.loadStudentFollowUps(this.props.studentObj._id)

        if (response) {
            this.setState({ arr: response.data })
        }
        this.setState({ loading: false })
    }

    showChildrenDrawer = () => {
        this.setState({
            childrenDrawer: true
        })
        setTimeout(async () => {
            await this.getAllSUbRatings(this.props.studentObj.rating);
            this.props.form.setFieldsValue({
                rating: this.props.studentObj.rating,
                subRating: this.props.studentObj.subRating
            })
        }, 1000)
    }

    onChildrenDrawerClose = () => {
        this.setState({
            childrenDrawer: false
        })
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values._id = this.props.studentObj._id
                dispatch(showLoader())

                let x = await Request.addFollowUp(values)

                dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.message
                    })

                    this.loadStudentFollowUps()
                    this.onChildrenDrawerClose()

                    form.resetFields()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.message
                    })
                }
            }
        })
    }

    render() {
        const {
            form: { getFieldDecorator }
        } = this.props
        const inputTypes = [
            {
                tabTitle: 'Add Follow Up',
                fields: [
                    {
                        label: 'Next Follow Up Date',
                        key: 'date',
                        type: 'date',
                        required: true
                    },
                    // {
                    //     label: 'Best Time To Call',
                    //     key: 'time',
                    //     type: 'time',
                    //     required: true
                    // },
                    {
                        label: 'Details',
                        key: 'detail',
                        type: 'textArea',
                        rows: 10,
                        required: true
                    },
                    // {
                    //     label: 'Follow-Up Tags',
                    //     key: 'followUpType',
                    //     type: 'select',
                    //     required: true,
                    //     options: this.state.followUpObject,
                    //     placeholder: 'Select follow-Up Tag',
                    //     onChange: v => {
                    //         this.props.form.setFieldsValue({
                    //             followUpType: v
                    //         })
                    //     }
                    // },
                    // {
                    //     label: 'Quality Rating *',
                    //     key: 'qualityRating',
                    //     type: 'select',
                    //     disabled: true,
                    //     required: true,
                    //     options: ['Qualified', 'Potential', 'Unqualified'],
                    //     onChange: v => {
                    //         this.props.form.setFieldsValue({
                    //             qualityRating: v
                    //         })
                    //     }
                    // },
                    // {
                    //     label: 'Conversion Rating *',
                    //     key: 'rating',
                    //     type: 'select',
                    //     required: true,
                    //     options: this.state.parentRatings && this.state.parentRatings.map(x => ({ _id: x._id, display: x.ratingName })),
                    //     placeholder: 'Select Rating',
                    //     onChange: v => {
                    //         this.getAllSUbRatings(v);
                    //         this.props.form.setFieldsValue({
                    //             rating: v,
                    //             subRating: ''
                    //         })
                    //     }
                    // },
                    // {
                    //     label: 'Rating Tags *',
                    //     key: 'subRating',
                    //     type: 'select',
                    //     required: true,
                    //     options: this.state.subRatings && this.state.subRatings.map(x => ({ _id: x._id, display: x.ratingName })),
                    //     placeholder: 'Select Rating',
                    //     onChange: v => {
                    //         this.props.form.setFieldsValue({
                    //             subRating: v
                    //         })
                    //     }
                    // }

                ]
            }
        ];

        const column = [
            {
                title: 'Followups',
                key: 'detail',
                dataIndex: 'detail',
                render: (val, record) => {
                    return (
                        <div>
                            <div style={{ color: 'green' }}>
                                Follow Up Date : {moment(record.followUpDate).format('lll')}<br />
                                Created Date : {moment(record.entryDate).format('lll')}
                                <div style={{ color: 'orange', float: 'right' }}>
                                    {' '}
                                    By ({record.assignByName})
                                </div>
                            </div>
                            <div>{val}</div>
                        </div>
                    )
                }
            },
            {
                title: 'Followups Out Come',
                key: 'followUpType',
                dataIndex: 'followUpType',
                render: (val, record) => {
                    return this.renderStatus(val)
                }
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Notes of {this.props.studentObj.name}{' '}

                            <RightsWrapper myRight={'FollowUps.add'}>
                                <button onClick={this.showChildrenDrawer} style={{ float: 'right', marginRight: 50 }}>
                                    <Icon type={'plus'} /> Add Note
                                </button>
                            </RightsWrapper>
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={this.state.visible}>
                <div>
                    <Table
                        showHeader={false}
                        dataSource={this.state.arr}
                        columns={column}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                        loading={this.state.loading}
                    />
                </div>

                <Drawer
                    title={
                        <div>
                            <Icon type={'calendar'} />
                            NEW NOTE
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.onChildrenDrawerClose}
                    visible={this.state.childrenDrawer}>
                    <div>
                        <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                            {inputTypes.map((itype, key) => {
                                return (
                                    <div key={key}>
                                        <GetAllFormFields
                                            inputSchema={inputTypes[key]}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </div>
                                )
                            })}

                            <Row>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </div>
                </Drawer>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListFollowUps)
